const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on("unmount", () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

import MiniCart from "./components/ui/cart/MiniCart";
import Countdown from "./components/ui/Countdown";
import ProductForm from "./components/product/ProductForm";

export const AppComponents = {
  ProductForm,
  Countdown,
  MiniCart,
};
